<template>
  <div class="pb100">
    <volunteerdata/>
    <crumbs/>
    <div class="container">
      <el-button type="primary" @click="centerDialogVisible = true">志愿团队注册</el-button>
      <type-screen
        modelType="volunteercommunity"
        :menu-id="this.$route.query.columnId"
        @typedata="typeDataList"
        @typeObj="selectType"/>
      <ul class="ul-model1 clearfix">
        <li v-for="(item, index) in List" :key="index">
          <router-link :to="'/volunteercommunitydetail?columnId=' + item.menuId + '&id=' + item.id">
            <div class="imgbox">
              <img class="imgtop" :src="getImage(item.image)" alt="">
            </div>
            <div class="txtbox">
              <h2 class="textover">{{ item.name }}</h2>
              <div class="descbox">
                <p class="textover">活动次数：<span>{{ item.activityNum }}</span></p>
                <p class="textover">服务类别：<span>{{ item.name }}</span></p>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
      <nodata v-show="nodataflag"/>
      <el-pagination
        v-if="listTotal > 12"
        @current-change="handleCurrentChange"
        :page-size="Param.limit"
        :pager-count="5"
        :current-page.sync="currentPage"
        layout="prev, pager, next"
        :total="listTotal"
        class="pagemodel1">
      </el-pagination>
      <el-dialog
        custom-class="volunteermodel1"
        title="欢迎注册"
        :visible.sync="centerDialogVisible"
        width="40%"
        center>
        <el-form ref="Formdata" :model="Fromdata" :rules="Rules" class="volunteer">
          <el-form-item label="团队名称" prop="name">
            <el-input v-model="Fromdata.name" placeholder="请输入团队名称"></el-input>
          </el-form-item>
          <div
            v-if="Fromdata.typeBinkList && Fromdata.typeBinkList.length > 0"
            v-for="(item, index) in Fromdata.typeBinkList"
            :key="index">
            <el-form-item :label="item.name">
              <el-select v-model="item.value" :placeholder="'请选择' + item.name">
                <el-option
                  :label="items.name"
                  :value="items.id"
                  v-for="(items, indexs) in item.newchildren"
                  :key="indexs"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="负责人姓名" prop="contactName">
            <el-input v-model="Fromdata.contactName" placeholder="请输入负责人姓名"></el-input>
          </el-form-item>
          <el-form-item label="负责人电话" prop="contactPhone">
            <el-input v-model="Fromdata.contactPhone" placeholder="请输入负责人电话"></el-input>
          </el-form-item>
          <el-form-item class="introduction" label="团队介绍" prop="introduction">
            <el-input type="textarea" v-model="Fromdata.introduction" placeholder="团队介绍"></el-input>
          </el-form-item>
          <el-form-item label="上传头像">
            <el-upload
              action
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-exceed = "overUpload"
              :http-request="upLoadimg"
              ref="uploads"
              :limit=1
              class="upload-demo"
            >
              <i slot="default" class="el-icon-plus"></i>
              <div class="defaulttext">点击上传</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="registerbtn">注册</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import volunteerdata from '@/view/volunteercenter/volunteerdata'
import typeScreen from '@/components/typescreen/index'
import { scrollAnimation } from '@/utils/index'
import nodata from '@/components/nodata/index'
import { VolunteercommunityList, registervcommunity } from '@/api/volunteer/index'
import { uploads } from '@/api/workCollect/index'
import qs from 'qs'
export default {
  name: 'volunteercommunity',
  meta: {
    showHeader: true
  },
  components: {
    typeScreen,
    crumbs,
    volunteerdata,
    nodata
  },
  data () {
    return {
      vcommunitytypeArr: [],
      Param: {
        fid: this.$cookie.get('culturalCloud_fid'),
        pageNum: 1,
        limit: 12,
        menuId: this.$route.query.columnId,
        type: ''
      },
      currentPage: 1,
      nodataflag: false,
      List: [],
      listTotal: 0,
      centerDialogVisible: false,
      Fromdata: {
        fid: this.$cookie.get('culturalCloud_fid'),
        menuId: this.$route.query.columnId,
        name: '',
        contactName: '',
        contactPhone: '',
        introduction: '',
        image: [],
        typeBinkList: []
      },
      Rules: {
        name: [{required: true, message: '团队名称不能为空', trigger: 'blur'}],
        contactName: [{required: true, message: '团队负责人名称不能为空', trigger: 'blur'}],
        contactPhone: [{required: true, message: '团队负责人联系方式不能为空', trigger: 'blur'}],
        introduction: [{required: true, message: '团队介绍不能为空', trigger: 'blur'}]
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    registerbtn () {
      this.$refs['Formdata'].validate((valid) => {
        if (valid) {
          if (this.Fromdata.image.length === 0) {
            this.$alert('请上传头像', '', {
              confirmButtonText: '确定'
            })
          } else {
            registervcommunity(qs.stringify(this.Fromdata)).then(res => {
              if (res.data.rel) {
                this.centerDialogVisible = false
                this.$message({
                  message: res.data.message,
                  type: 'success',
                  duration: 1500
                })
              } else {
                this.$message.error(res.data.message)
              }
            })
          }
        }
      })
    },
    typeDataList (val) {
      this.Fromdata.typeBinkList = val.customType
      if (this.Fromdata.typeBinkList.length > 0) {
        for (let i = 0; i < this.Fromdata.typeBinkList.length; i++) {
          this.Fromdata.typeBinkList[i].newchildren = this.Fromdata.typeBinkList[i].children.slice()
        }
      }
    },
    /* 筛选条件 */
    selectType (obj) {
      this.Param.type = obj.customTypeId
      this.Param.pageNum = 1
      this.currentPage = 1
      this.getList()
    },
    // 分页触发
    handleCurrentChange (val) {
      this.Param.page = val
      const currentY = document.documentElement.scrollTop || document.body.scrollTop
      scrollAnimation(currentY, 0)
      this.getList()
    },
    getList () {
      VolunteercommunityList(this.Param).then(res => {
        if (res.data.status === 0) {
          this.listTotal = res.data.totalSize
          if (this.listTotal === 0) {
            this.nodataflag = true
          } else {
            this.nodataflag = false
          }
          this.List = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    upLoadimg (param) {
      this.Fromdata.image.push(param)
      this.getImgs()
    },
    getImgs () {
      const paramsData = new FormData()
      this.Fromdata.image.forEach((it, index) => {
        paramsData.append('file', it.file)
      })
      // console.log(paramsData);
      uploads(paramsData).then(res => {
        this.imgarr = []
        res.data.data.forEach(item => {
          this.imgarr.push(item.http)
        })
        this.imgstring = this.imgarr[0]
        this.Fromdata.image = this.imgstring
      })
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isJPG2 = file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning('只支持jpg或png格式图片')
      }
      if (!isLt5M) {
        this.$message.warning('请上传5MB以内的图片!')
      }
      return (isJPG || isJPG2 || isPNG) && isLt5M
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove (file, fileList) {
      // console.log(file, fileList);
      this.Fromdata.image.forEach((item, index) => {
        if (item.file === file.raw) {
          this.Fromdata.image.splice(index, 1)
        }
      })
    },
    overUpload () {
      this.$message('只能上传一张封面')
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .volunteermodel1{
  height: 500px;
  overflow-y: auto;
  padding: 0 0 30px;
}
/deep/ .el-form.volunteer{
  .el-form-item{
    .el-form-item__label{
      width: 100px;
    }
    .el-form-item__content{
      width: 50%;
      float: left;
      .el-select{
        width: 100%;
      }
      .upload-demo{
        .el-upload{
          position: relative;
          .defaulttext {
            width: 80px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            color: #c5c5c5;
            position: absolute;
            top: 60%;
            left: 50%;
            margin-left: -40px;
          }
        }
      }
    }
    &.introduction{
      .el-form-item__content{
        width: 78%;
      }
    }
  }
}
.ul-model1{
  li{
    a{
      .txtbox{
        .descbox{
          height: 54px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/volunteercenter/vcommunitylist.vue